import { useEffect, useState } from "react";
import { SnackbarProvider } from "notistack";

import NETWORKS from "./networks";
import SessionContext from "./contexts/session";
import { getSettings } from "./models/settings";

import AppRoutes from "./AppRoutes";

import "./App.css";
import "./team.scss";

import "@rainbow-me/rainbowkit/styles.css";

import {
  getDefaultWallets,
  RainbowKitProvider,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import { configureChains, createClient, WagmiConfig } from "wagmi";
// import { infuraProvider } from "wagmi/providers/infura";
import { publicProvider } from "wagmi/providers/public";

import { useAccount } from "wagmi";
import { useNetwork } from "wagmi";
const { chains, provider } = configureChains(
  Object.values(NETWORKS).filter(network => !network.disabled).map((network) => ({
    id: network.chainIdDec,
    name: network.chainName,
    network: network.chainName,
    iconUrl: network.ui.menuIcon,
    iconBackground: "#fff",
    nativeCurrency: {
      decimals: 18,
      name: network.ui.symbol,
      symbol: network.ui.symbol,
    },
    rpcUrls: {
      default: {
        http: [network.wallet_addEthereumChain.rpcUrls[0]],
      },
    },
    blockExplorers: {
      default: {
        name: network.wallet_addEthereumChain.chainName,
        url: network.wallet_addEthereumChain.blockExplorerUrls[0],
      },
      etherscan: {
        name: network.wallet_addEthereumChain.chainName,
        url: network.wallet_addEthereumChain.blockExplorerUrls[0],
      },
    },
    testnet: false,
  })),
  [
    // infuraProvider({ apiKey: "e7d641158d6f4a3fa89e8142900fcb5d" }),
    publicProvider(),
  ]
);

const { connectors } = getDefaultWallets({
  appName: "nice2win",
  chains,
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
});

export default function App() {
  const [selectedNetwork, setSelectedNetwork] = useState(
    NETWORKS[process.env.NODE_ENV === "development" ? 80001 : 56]
  );

  const { address } = useAccount();
  const { chain, chains } = useNetwork();

  const [settings, setSettings] = useState();
  const [user, setUser] = useState();
  const [volume, setVolume] = useState(0.5);

  const [isNetworkSwitching, setIsNetworkSwitching] = useState(false);
  const [isAwaitingWallet, setIsAwaitingWallet] = useState(false);
  const [hasInsufficientFunds, setHasInsufficientFunds] = useState(false);
  const [isBelowMinimumBet, setIsBelowMinimumBet] = useState(false);

  const [pending, setPending] = useState([]);
  const [animationQueue, setAnimationQueue] = useState([]);
  const [executing, setExecuting] = useState();

  const wrongNetwork = address && selectedNetwork.chainIdDec !== chain?.id;

  useEffect(() => {
    let didCancel = false;
    async function updateSettings() {
      const settings = await getSettings(selectedNetwork.chainIdDec);
      if (!didCancel) {
        setSettings(settings);
      }
    }
    updateSettings();
    return () => {
      didCancel = true;
    };
  }, [selectedNetwork]);

  useEffect(() => {
    if (address && chain && !chain.unsupported) {      
      setSelectedNetwork(NETWORKS[chain.id]);
    }
  }, [address, chain]);  
  return (
    <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider
        modalSize="compact"
        chains={chains}
        theme={darkTheme()}
      >
        <SessionContext.Provider
          value={{
            account: address,
            chainId: chain?.id,
            selectedNetwork,
            setSelectedNetwork,
            settings,
            isAwaitingWallet,
            setIsAwaitingWallet,
            pending,
            setPending,
            animationQueue,
            setAnimationQueue,
            executing,
            setExecuting,
            hasInsufficientFunds,
            setHasInsufficientFunds,
            isBelowMinimumBet,
            setIsBelowMinimumBet,
            volume,
            setVolume,
            user,
            wrongNetwork,
            setUser,
            isNetworkSwitching: wrongNetwork || isNetworkSwitching,
            setIsNetworkSwitching,
            // connectWallet,
            // disconnect,
            // switchNetwork,
            // signMessage: signer?.signMessage,
          }}
        >
          <SnackbarProvider>
            <AppRoutes />
          </SnackbarProvider>
        </SessionContext.Provider>
      </RainbowKitProvider>
    </WagmiConfig>
  );
}
